import { render, staticRenderFns } from "./ImageCheckboxGroup.vue?vue&type=template&id=5b0d566f&"
import script from "./ImageCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./ImageCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./ImageCheckboxGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports